module.exports = __webpack_public_path__ + "assets/img/202110-2W.7c92f518.png";